//
//
//
//

import { User } from "@/models";
import AV from "leancloud-storage";

export default {
  name: "weiboLogIn",
  created() {
    let code = this.$route.query.code;
    let from = this.$route.query.state;

    User.logInByWeibo(code)
      .then((response) => {
        let authData = response.authData;

        AV.User.signUpOrlogInWithAuthData(authData, "weibo").then((user) => {
          if (user.get("bindWeibo")) {
            this.$store.commit("logIn", user.toJSON());
            this.$router.push({ path: from || "/" });
          } else {
            let avatar = response.avatar;
            let name = response.name;
            let avatarFile = AV.File.withURL("avatar.png", avatar);

            Promise.all([
              response,
              user,
              AV.Cloud.run("getNonRepetitiveUsername", { username: name }),
              avatarFile.save(),
            ])
              .then((data) => {
                let response = data[0];
                let user = data[1];
                let name = data[2];
                let avatarFile = data[3];

                user.set("username", name);
                user.set("avatar", avatarFile);
                user.set("bindWeibo", true);

                return user.save();
              })
              .then((user) => {
                this.$store.commit("logIn", user.toJSON());
                this.$router.push({ path: from || "/" });
              })
              .catch((err) => {
                this.$router.push({ path: "/" });
              });
          }
        });
      })
      .catch((err) => {
        this.$router.push({ path: "/" });
      });
  },
  metaInfo: {
    title: "登录中...",
    titleTemplate: null,
  },
  data() {
    return {};
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/pages/account/WeiboLogIn.vue